module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "kostnadsbaserad-hyra"
    }
  }, [_c('h1', [_vm._v("Kostnadsbaserad Hyra")]), _vm._v(" "), _c('p', [_vm._v("En "), _c('strong', [_vm._v("kostnadsbaserad hyra")]), _vm._v(" får inte vara påtagligt högre än summan av uthyrarens kapitalkostnad och driftkostnad.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93c39dba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kostnadsbaserad.vue
// module id = 22
// module chunks = 0